import angular from 'angular';
import ngCookies from 'angular-cookies';
import constants from 'app/constants';
import {
  pmDataService,
  reportsDataService,
  ssDialogService,
  loaderService
} from 'app/services';
import {
  alerts
} from 'app/components/global';
import controller from './generate-document-dialog.controller';
import template from './generate-document-dialog.html';

// Validation
import assessmentGenerateFullReportMessagesTpl from '../../messages/assessment.generate.full.report.messages.html';

class dialogService {
  getOptions($event, { assessment }) {
    return {
      controller,
      controllerAs: 'generateDocumentDialogVM',
      locals: {
        assessment
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.ecat.generateDocumentDialog', [
  constants,
  ngCookies,
  pmDataService,
  reportsDataService,
  ssDialogService,
  loaderService,
  alerts,
])
  .service('ecatGenerateDocumentDialog', dialogService)
  .run(($templateCache) => {
    $templateCache.put('assessment.generate.full.report.messages.html', assessmentGenerateFullReportMessagesTpl);
  })
  .name;
